export default class IconRenderer
{

  drawOn(ctx, icon, x, y, width, height) {

    let path = new Path2D('M20,2 L20,2 C13.37567,2.00743988 8.00744,7.37567 8,14 C8,19.265 15.5,32.0375 18.722,37.286 L18.7219999,37.2859999 C18.9950569,37.7298319 19.4788969,38.0000167 20,38.0000167 L20,38.0000167 C20.5220914,38.0024825 21.0072109,37.7308834 21.2779999,37.2844999 C24.5,32.0389999 32,19.2709999 32,14 L32,14.0003756 C31.9927677,7.37604559 26.6247053,2.00765059 20.0003753,2 L20,2 Z M20.0000001,19.25 L19.9999999,19.25 C17.1004999,19.25 14.7499999,16.8995 14.7499999,14 C14.7499999,11.1005 17.1004999,8.75 19.9999999,8.75 C22.8994999,8.75 25.2499999,11.1005 25.2499999,14 L25.2499999,13.9999998 C25.2499999,16.8994998 22.8994999,19.25 19.9999999,19.25 L20.0000001,19.25 Z');

    let size = {
      width: 40,
      height: 40
    };



    ctx.save();
    ctx.translate(x, y);
    ctx.scale(width / size.width, height / size.height);
    ctx.fill(path, 'evenodd');
    ctx.restore();


  }

}
